import React, {Component} from 'react';
import converter from 'number-to-words';
import $ from 'jquery';
import moment from 'moment';
import {Pronoun} from '../../../../model/Helper';
import {blank_line} from '../../../../model/Const';

class Preview extends Component {

    constructor(props) {
        super(props);
        this.state = {
            focus: ".paper-title"
        }
    }

    isVisible(el) {
		var elementTop = $(el).offset().top;
		var elementBottom = elementTop + $(el).outerHeight();
	
		var viewportTop = $(window).scrollTop();
		var viewportBottom = viewportTop + $(window).height();
	
		return elementBottom > viewportTop && elementTop < viewportBottom;
    }

    componentDidMount() {

		$(window).scroll(()=>{

			// This setup will be enabled only with at least md window width
			if($(window).width()>767){
				// Header setup
				// Make preview stay at the top and fixed display when header is not visible
				if(this.isVisible(".header")){
					////console.log("Visible");
					$(".right-preview .preview").css({
						"position": "relative",
						"top": "auto",
						"padding-right": "0"
					});
				} else {
					////console.log("Not visible");
					$(".right-preview .preview").css({
						"position": "fixed",
						"top": "1rem",
						"padding-right": "15px"
					});
				}

			}
        });
        
    }
    
    componentWillReceiveProps(newProps) {
		let ff = newProps.formFocus?newProps.formFocus:'paper-title';

        this.setState({
            focus: '.'+ff
        }, ()=>{
            //console.log(this.state.focus)
            let screenPos = $(window).height()/3;
            let el = $(this.state.focus).length?$(this.state.focus):$(".paper-title");
            let scrollVal = el.get(0).offsetTop-screenPos || 0;
            
            $(".paper").animate({
                scrollTop: scrollVal
            }, 100);
            
        });
    }
    
    render() {

        let p = this.props.details.property;
        let s = this.props.details.lender[0];
        let b = this.props.details.borrower[0];
        let l = this.props.details.loan;


        let blankLine = blank_line;

        let loanPrincipalNumber = l.principal ? parseFloat(l.principal) : 0;
        let loanPrincipalText = (typeof parseFloat(loanPrincipalNumber) === "number" && parseFloat(loanPrincipalNumber)>0) ?
        converter.toWords(loanPrincipalNumber) : 
        blankLine;
        let loanInterestRateNumber = l.interestRate ? parseFloat(l.interestRate) : 0;
        let loanInterestRateText = (typeof parseFloat(loanInterestRateNumber) === "number" && parseFloat(loanInterestRateNumber)>0) ?
        converter.toWords(loanInterestRateNumber) : 
        blankLine;
        let loanInterestRateBasis = l.interestRateBasis==="Monthly" ? `month` : `year`;
        let loanDurationNumber = l.duration ? parseFloat(l.duration) : 0;
        let loanDurationText = (typeof parseFloat(loanDurationNumber) === "number" && parseFloat(loanDurationNumber)>0) ?
        converter.toWords(loanDurationNumber) : 
        blankLine;
        let loanFirstInstallment = l.firstInstallment;
        let loanInterval = l.interval;
        let computationOfInterest = l.computationOfInterest;

        let monthlyAmort = 0;
        let loanInt = 0;
        ////console.log(`${l.principalDemandable} === Pro rated on the number of installments`)
        if(l.interestRateBasis==="Monthly"){
            if(l.principalDemandable==="Pro rated on the number of installments"){
                loanInt = (loanPrincipalNumber*(loanInterestRateNumber/100))*loanDurationNumber;
                monthlyAmort = (loanPrincipalNumber+loanInt)/loanDurationNumber;
            }
            if(l.principalDemandable==="On the last installment"){
                loanInt = (loanPrincipalNumber*(loanInterestRateNumber/100))*loanDurationNumber;
                monthlyAmort = (loanInt)/loanDurationNumber;
            }
        }

        if(l.interestRateBasis==="Yearly"){
            loanInt = (loanPrincipalNumber*(loanInterestRateNumber/100))*loanDurationNumber;

            /**
             * Compute for the factor rate
             */
            let rateInDecimal = loanInterestRateNumber/100;
            let rateInDecimalPerMonth = rateInDecimal/12;
            let factorRate = rateInDecimalPerMonth / (1-(1+rateInDecimalPerMonth)**-(loanDurationNumber*12))
            //console.log("factor rate:", factorRate)

            if(loanInterval==="Monthly"){

                // Check computation of interest simple straigh or diminishing balance

                computationOfInterest==="Simple/Straight Computation" ?
                    monthlyAmort = (loanPrincipalNumber+loanInt)/(loanDurationNumber*12) :
                    monthlyAmort = (loanPrincipalNumber * factorRate ) // diminishing balance
                

            }
            if(loanInterval==="Yearly"){
                if(l.principalDemandable==="Pro rated on the number of installments"){
                    monthlyAmort = (loanPrincipalNumber+loanInt)/(loanDurationNumber);
                }
                if(l.principalDemandable==="On the last installment"){
                    monthlyAmort = (loanInt)/loanDurationNumber;
                }
            }
        }

        let lenderName = (s.lenderFname || s.lenderMname || s.lenderLname) ? 
                                (s.lenderFname+(s.lenderMname?` ${s.lenderMname}`:"")+(s.lenderLname?` ${s.lenderLname}`:"")+(s.lenderSuffix?` ${s.lenderSuffix}`:"")): 
                                blankLine;

        let lenderCorporationName = s.lenderCorporationName ? s.lenderCorporationName : blankLine;

        let borrowerName = (b.borrowerFname || b.borrowerMname || b.borrowerLname) ? 
                                (b.borrowerFname+(b.borrowerMname?` ${b.borrowerMname}`:"")+(b.borrowerLname?` ${b.borrowerLname}`:"")+(b.borrowerSuffix?` ${b.borrowerSuffix}`:"")): 
                                blankLine;

        //let borrowerCorporationName = b.borrowerCorporationName ? b.borrowerCorporationName : blankLine;
        
        let borrowerCorporationRepresentativeName = (b.borrowerCorporationRepresentativeFname || b.borrowerCorporationRepresentativeMname || b.borrowerCorporationRepresentativeLname) ? 
                                (b.borrowerCorporationRepresentativeFname+(b.borrowerCorporationRepresentativeMname?` ${b.borrowerCorporationRepresentativeMname}`:"")+(b.borrowerCorporationRepresentativeLname?` ${b.borrowerCorporationRepresentativeLname}`:"")+(b.borrowerCorporationRepresentativeSuffix?` ${b.borrowerCorporationRepresentativeSuffix}`:"")): 
                                blankLine;

        let borrowerCorporationName = b.borrowerCorporationName || blankLine;
        let borrowerCorporationRepresentativePosition = b.borrowerCorporationRepresentativePosition || blankLine;

        /**
         * Create schedule of payment
         * When using table-responsive - it cause error on dompdf, can not create pdf
         */
        let scheduleOfPayment = `
            <table class="table table-bordered table-sm table-responsive">
                <tbody>
        `;

        if(l.interestRateBasis==="Yearly" && loanInterval==="Monthly" && l.computationOfInterest==="Diminishing Balance") {
            scheduleOfPayment+=`<tr>
                <td class="font-weight-bold text-center">Payment Date</td>
                <td class="font-weight-bold text-center">Beginning Balance</td>
                <td class="font-weight-bold text-center">Amortization</td>
                <td class="font-weight-bold text-center">Principal</td>
                <td class="font-weight-bold text-center">Interest</td>
                <td class="font-weight-bold text-center">Ending Balance</td>
            </tr>`;
        } else {
            scheduleOfPayment+=`<tr>
                <td class="font-weight-bold text-center">Payment Date</td>
                <td class="font-weight-bold text-center">Amount</td>
                <td class="font-weight-bold text-center">Amortization</td>
                <td class="font-weight-bold text-center">Remaining Balance</td>
            </tr>`;
        }

        // Monthly
        if(l.interestRateBasis==="Monthly") {
            // Monthly -> On the last installment
            if(l.principalDemandable==="On the last installment"){

                [...Array(loanDurationNumber)].forEach((obj, i)=>{
                    scheduleOfPayment+=`
                        <tr key=${i}>
                            <td>
                                ${moment(loanFirstInstallment).add(i, 'month').format('LL')}
                            </td>
                            <td class="text-right">
                                ${Number((loanPrincipalNumber+loanInt)-(monthlyAmort*i)).toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}
                            </td>
                            <td class="text-right">
                                ${Number(monthlyAmort+((i+1===loanDurationNumber) ? loanPrincipalNumber : 0)).toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}
                            </td>
                            <td class="text-right">
                                ${Number((loanPrincipalNumber+loanInt)-((monthlyAmort*(i+1)+((i+1===loanDurationNumber) ? loanPrincipalNumber : 0)))).toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}
                            </td>
                        </tr>
                    `;
                })
                
            }

            if(l.principalDemandable==="Pro rated on the number of installments"){

                [...Array(loanDurationNumber)].forEach((obj, i)=>{
                    scheduleOfPayment+=`
                        <tr key=${i}>
                            <td>
                                ${moment(loanFirstInstallment).add(i, 'month').format('LL')}
                            </td>
                            <td class="text-right">
                                ${Number((loanPrincipalNumber+loanInt)-(monthlyAmort*i)).toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}
                            </td>
                            <td class="text-right">
                                ${Number(monthlyAmort).toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}
                            </td>
                            <td class="text-right">
                                ${Number((loanPrincipalNumber+loanInt)-((monthlyAmort*(i+1)))).toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}
                            </td>
                        </tr>
                    `;
                })
                
            }

        }

        // Yearly
        if(l.interestRateBasis==="Yearly") {
            if(loanInterval==="Monthly") {
                if(l.computationOfInterest==="Simple/Straight Computation"){
                    [...Array(loanDurationNumber*12)].forEach((obj, i)=>{
                        scheduleOfPayment+=`
                            <tr key=${i}>
                                <td>
                                    ${moment(loanFirstInstallment).add(i, 'month').format('LL')}
                                </td>
                                <td class="text-right">
                                    ${Number((loanPrincipalNumber+loanInt)-(monthlyAmort*i)).toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}
                                </td>
                                <td class="text-right">
                                    ${Number(monthlyAmort).toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}
                                </td>
                                <td class="text-right">
                                    ${Number((loanPrincipalNumber+loanInt)-((monthlyAmort*(i+1)))).toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}
                                </td>
                            </tr>
                        `;
                    })
                }
                if(l.computationOfInterest==="Diminishing Balance"){
                    
                    let beginning, ending, principal, interest;

                    [...Array(loanDurationNumber*12)].forEach((obj, i)=>{

                        interest = i>0?ending * ((loanInterestRateNumber/100)/12) : loanPrincipalNumber * ((loanInterestRateNumber/100)/12);                        
                        beginning = i>0?ending:loanPrincipalNumber - (i>0?(monthlyAmort-interest):0);
                        principal = monthlyAmort - interest;                     
                        ending = beginning - principal;

                        scheduleOfPayment+=`
                            <tr key=${i}>
                                <td>
                                    ${moment(loanFirstInstallment).add(i, 'month').format('LL')}
                                </td>
                                <td class="text-right">
                                    ${Number(beginning).toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}
                                </td>
                                <td class="text-right">
                                    ${Number(monthlyAmort).toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}
                                </td>
                                <td class="text-right">
                                    ${Number(principal).toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}
                                </td>
                                <td class="text-right">
                                    ${Number(interest).toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}
                                </td>
                                <td class="text-right">
                                    ${Number(ending).toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}
                                </td>
                            </tr>
                        `;
                    })
                }
            }
            if(loanInterval==="Yearly"){
                if(l.principalDemandable==="On the last installment"){

                    [...Array(loanDurationNumber)].forEach((obj, i)=>{
                        scheduleOfPayment+=`
                            <tr key=${i}>
                                <td>
                                    ${moment(loanFirstInstallment).add(i, 'year').format('LL')}
                                </td>
                                <td class="text-right">
                                    ${Number((loanPrincipalNumber+loanInt)-(monthlyAmort*i)).toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}
                                </td>
                                <td class="text-right">
                                    ${Number(monthlyAmort+((i+1===loanDurationNumber) ? loanPrincipalNumber : 0)).toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}
                                </td>
                                <td class="text-right">
                                    ${Number((loanPrincipalNumber+loanInt)-((monthlyAmort*(i+1)+((i+1===loanDurationNumber) ? loanPrincipalNumber : 0)))).toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}
                                </td>
                            </tr>
                        `;
                    })
                    
                }
    
                if(l.principalDemandable==="Pro rated on the number of installments"){
    
                    [...Array(loanDurationNumber)].forEach((obj, i)=>{
                        scheduleOfPayment+=`
                            <tr key=${i}>
                                <td>
                                    ${moment(loanFirstInstallment).add(i, 'year').format('LL')}
                                </td>
                                <td class="text-right">
                                    ${Number((loanPrincipalNumber+loanInt)-(monthlyAmort*i)).toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}
                                </td>
                                <td class="text-right">
                                    ${Number(monthlyAmort).toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}
                                </td>
                                <td class="text-right">
                                    ${Number((loanPrincipalNumber+loanInt)-((monthlyAmort*(i+1)))).toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}
                                </td>
                            </tr>
                        `;
                    })
                    
                }
            }
        }

        scheduleOfPayment+=`</tbody></table>`;

        return (
            <div className="preview">
                <div className="default-preview-fade top"></div>
                <div className="top-preview">
                    <div className="text-center">
                        <p>Preview</p>
                    </div>
                    
                    <div className="paper">
                    <div className="paper-inner">
                        
                        <div className="paper-title text-center">
							Promissory Note
						</div>

                        <div>
                            <p>
                                FOR VALUE RECEIVED, the undersigned Maker, promises to pay to the order of <span className="dynamic-data text-uppercase font-weight-bold lender_lenderFname lender_lenderMname lender_lenderLname lender_lenderSuffix lender_lenderGender lender_lenderCorporationName">{s.legalPersonality==="Natural Person" ? lenderName : lenderCorporationName}</span>, (hereinafter referred to as “Payee”), the principal amount of <span className="dynamic-data text-uppercase loan_principal">{loanPrincipalText} Pesos (P{Number(l.principal).toLocaleString(undefined, {minimumFractionDigits:2, maximumFractionDigits:2})})</span>, plus interest of <span className="dynamic-data loan_interestRate">{loanInterestRateText} percent ({loanInterestRateNumber}%)</span> per <span className="dynamic-data loan_interestRateBasis">{loanInterestRateBasis}</span> on the principal, for a duration of <span className="dynamic-data">{loanDurationText} ({loanDurationNumber}) {loanInterestRateBasis}</span>. For convenience, a schedule of payment is hereby provided below, thus:
                            </p>
                        </div>

                        {/** Start schedule */}
                        <div className="text-center responsive-table-wrapper loan_firstInstallment loan_principalDemandable loan_interval loan_computationOfInterest">
                            <div className="d-inline-block" dangerouslySetInnerHTML={{__html:scheduleOfPayment}} />
                        </div>

                        <div>
                            <p>
                                This Promissory Note (hereinafter referred to as “Note”) shall be subject to the following conditions, thus:
                            </p>
                            <ol type="a">
                                <li>
                                    The Maker shall turn over post-dated checks to the Payee in accordance with the above schedule of payment.
                                </li>
                                <li>
                                    Any default or delay in the payment of any installment shall bear a penalty of three percent (3%) per month.
                                </li>
                                <li>
                                    The Maker shall have the right at any time or from time to time to pay all or a portion of the principal without premium or penalty.
                                </li>
                                <li>
                                    The Maker hereby waives demand, diligence, presentment for payment, protest or notice of demand and exercise of any option hereunder.
                                </li>
                                <li>
                                    The Maker agrees that the granting of any extension or extensions of time for payment of any sum or sums due hereunder, or for the performance of any covenant, condition or agreement hereof or the release of other or additional security, shall in no way release or discharge the liability of the Maker.
                                </li>
                                <li>
                                    Time is of the essence in this Note and each and every term and provision herein is intended to insure the prompt payment of the obligation.
                                </li>
                            </ol>
                        </div>

                        <div>
                            <p>
                                IN WITNESS WHEREOF, the Maker has hereunto set {Pronoun("his", b.borrowerGender, b.legalPersonality, "borrower")} hand this _______________ in _______________.
                            </p>
                        </div>

                        <br />
                        <br />
                        
                        <div className="text-right">
                            <div className="d-inline-block text-center">
                                <div className="font-weight-bold text-uppercase borrower_legalPersonality borrower_isLegalAge borrower_borrowerFname borrower_borrowerMname borrower_borrowerLname borrower_borrowerSuffix borrower_borrowerGender borrower_borrowerCorporationName borrower_borrowerCorporationRepresentativeFname borrower_borrowerCorporationRepresentativeMname borrower_borrowerCorporationRepresentativeLname borrower_borrowerCorporationRepresentativeSuffix borrower_borrowerCorporationRepresentativeGender borrower_borrowerCorporationRepresentativePosition">
                                    {b.legalPersonality==="Natural Person"?
                                        borrowerName:
                                        <span>
                                            {borrowerCorporationRepresentativeName}<br />
                                            <span className="text-capitalize font-weight-normal">{borrowerCorporationName}</span><br />
                                            <span className="text-capitalize font-weight-normal">{borrowerCorporationRepresentativePosition}</span>
                                        </span>}
                                </div>
                                <div>
                                    <em>Maker</em>
                                </div>
                            </div>
                        </div>

                    </div>
                    </div> {/** End of paper */}

                </div>

                <div className="default-preview-fade"></div>
            </div>
        );
    }

}

export default Preview;



// WEBPACK FOOTER //
// ./src/pages/contracts/business/promissory-note/Preview.js